export { default as ProductionCostSlot } from './ProductionCostSlot';
